import { getAppSettings } from "@/common/api";
import { useQuery } from "@tanstack/react-query"

const useAppSettings = () => {
  const query = useQuery({
    queryKey: ["app-settings"],
    queryFn: getAppSettings,
    refetchOnWindowFocus: false,
    staleTime: 60 * 60 * 1000, // 1 hour
    refetchOnMount: true
  });

  return query;
}

export default useAppSettings;